import victoriaPic from "../assets/pictures/actors/Victoria Strange.png";
import victoriaPolaroid from "../assets/pictures/actors/Polaroid - Victoria Strange.png";
import jamesPic from "../assets/pictures/actors/James Jelin Headshot.jpg";
import jamesPolaroid from "../assets/pictures/actors/Polaroid - James Jelin.png";
import anniePic from "../assets/pictures/actors/Annie Donley Headshot.jpg";
import anniePolaroid from "../assets/pictures/actors/Annie Donley poloroid.png";
import dariaPic from "../assets/pictures/actors/Daria Good.jpg";
import dariaPolaroid from "../assets/pictures/actors/Daria Good poloroid.png";
import jeffPic from "../assets/pictures/actors/Jeff Murdoch Headshot.jpg";
import jeffPolaroid from "../assets/pictures/actors/Jeff Murdoch  polaroid.png";
import prescottPic from "../assets/pictures/actors/Prescott Gadd Headshot.jpg";
import prescottPolaroid from "../assets/pictures/actors/Prescott Gadd polaroid.png";
import alexPic from "../assets/pictures/actors/AlexFelderHeadshot.jfif";
import alexPolaroid from "../assets/pictures/actors/Alex Felder Polaroid.png";
import samPic from "../assets/pictures/actors/sam celeste headshot.jpg";
import samPolaroid from "../assets/pictures/actors/Sam Celeste Polaroid.png";

/** Bundled headshots/polaroids for actors seeded without external URLs. */
export const LOCAL_ACTOR_ASSETS = {
  Victoria: { headshot: victoriaPic, polaroid: victoriaPolaroid },
  James: { headshot: jamesPic, polaroid: jamesPolaroid },
  Annie: { headshot: anniePic, polaroid: anniePolaroid },
  Daria: { headshot: dariaPic, polaroid: dariaPolaroid },
  Jeff: { headshot: jeffPic, polaroid: jeffPolaroid },
  Alex: { headshot: alexPic, polaroid: alexPolaroid },
  Prescott: { headshot: prescottPic, polaroid: prescottPolaroid },
  Sam: { headshot: samPic, polaroid: samPolaroid },
  SampleJeff: { headshot: jeffPic, polaroid: jeffPolaroid },
  SamplePrescott: { headshot: prescottPic, polaroid: prescottPolaroid },
};

function isRemoteUrl(url) {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  return (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("/")
  );
}

/** Resolve headshot or polaroid: prefer stored URL, else local asset by actor key. */
export function resolveActorImage(actor, type) {
  if (!actor) return null;
  const stored = type === "polaroid" ? actor.polaroidUrl : actor.headshotUrl;
  if (isRemoteUrl(stored)) return stored.trim();

  const local = LOCAL_ACTOR_ASSETS[actor.key];
  if (!local) return null;
  return type === "polaroid" ? local.polaroid : local.headshot;
}

export function actorDisplayName(actor) {
  if (!actor) return "";
  return [actor.firstName, actor.lastName].filter(Boolean).join(" ").trim() || actor.key;
}

export async function fetchActors(apiUrl, subdomain) {
  const site = subdomain === "seattle" ? "seattle" : "app";
  const res = await fetch(`${apiUrl}/api/actors?subdomain=${site}`);
  if (!res.ok) throw new Error("Failed to load actors");
  return res.json();
}
